<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-01-16 14:47:34
 * @LastEditors: 刘小二
 * @LastEditTime: 2023-02-16 16:29:41
 * @Description: 特材复配
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/smart/warehouse/smartConfig.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">特材成品名称</span>
                <el-input v-model="tableParam.productName" style="width: 200px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">成品型号</span>
                <el-input v-model="tableParam.type" style="width: 200px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">状态</span>
                <el-select v-model="tableParam.enable" clearable placeholder="请选择">
                  <el-option label="启用" :value="1"></el-option>
                  <el-option label="禁用" :value="0"></el-option>
                </el-select>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" @click="init()">重 置</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small" class="bottom_all" style="margin-left: 0" @click="(tankListArrlist = []), addFromDate('添加')">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'RIYONG') !== -1" size="small" class="bottom_three" @click="Update(1)">
                <i class="icon iconfont iconicon_button_startuse" style="font-size: 12px"></i>
                启用
              </el-button>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'JINYONG') !== -1" size="small" class="bottom_four" @click="Update(0)">
                <i class="icon iconfont iconicon_button_disable1" style="font-size: 12px"></i>
                禁用
              </el-button>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
              <el-table-column align="center" type="selection"></el-table-column>
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
                  <template slot-scope="scope">
                    <span v-if="scope.row.enable == 0 && item.label == '状态'" style="color: #969799">禁用</span>
                    <span v-if="scope.row.enable == 1 && item.label == '状态'" style="color: #00a754">启用</span>
                    <span v-if="item.label == '入库记录'" style="color: #00a754" @click="look4Fun(scope.row)">明细</span>
                    <span v-if="item.label == '操作'">
                      <el-dropdown :hide-on-click="false" trigger="click">
                        <el-button size="mini" class="bottom_one">更多</el-button>
                        <el-dropdown-menu slot="dropdown" style="text-align: left">
                          <el-dropdown-item>
                            <el-button class="bottom_one" style="margin: 5px 0" size="mini" @click="updateFromDate(scope.row, '修改')">
                              <i class="icon iconfont iconicon_button_modification" style="font-size: 12px"></i>
                              修改
                            </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button class="bottom_one" size="mini" style="margin: 5px 0" @click="look6Fun(scope.row)"> 配比设置 </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button class="bottom_one" size="mini" style="margin: 5px 0" @click="look1Fun(scope.row)"> 入库 </el-button>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </span>
                    <span v-if="item.label !== '操作' && item.label !== '状态' && item.label !== '入库记录'">{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
          <div class="card_bottom">
            <div class="card_bottom_left">
              <div class="top_page_totle">总共{{ total }}条</div>
              <el-pagination
                :current-page.sync="tableParam.page"
                :page-size="tableParam.pageSize"
                :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
                layout="prev,pager,sizes,next,jumper"
                :total="total"
                @size-change="sizeChange"
                @current-change="gettableData()"
              ></el-pagination>
            </div>
            <div>
              <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    <!-- 添加/修改 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" style="padding: 20px" :inline="true" :model="fromDate" label-width="110px">
          <el-form-item prop="stationId" :rules="[{ required: true, message: '请选择所属站点', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">站 点</span>
            <el-select ref="station" v-model="fromDate.stationId" placeholder="请选择">
              <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id" @click.native="selectStationFun(item)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="productName" :rules="[{ required: true, message: '请输入特材成品名称', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">特材成品名称</span>
            <el-input v-model="fromDate.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="type" :rules="[{ required: true, message: '请输入成品型号', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">成品型号</span>
            <el-input v-model="fromDate.type" placeholder="请输入" clearable> </el-input>
          </el-form-item>
          <el-form-item prop="rawWarehouseId" :rules="[{ required: true, message: '请选择原料库存仓', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">成品库</span>
            <el-select ref="tankListArr" v-model="fromDate.rawWarehouseId" placeholder="请选择">
              <el-option v-for="item in rawMaterialList" :key="item.rawWarehouseId" :label="item.name" :value="item.rawWarehouseId" @click.native="selectRawWarehouseFun(item)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="enable">
            <el-radio-group v-model="fromDate.enable">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="addDialog = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="pagessubmitFromDate()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 入库 -->
    <el-dialog v-dialogDrag :visible.sync="look1Type" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">入库</span>
      <div class="dialoginfo">
        <el-form ref="look1Form" style="padding: 20px" :inline="true" :model="look1Form" label-width="110px">
          <el-form-item label="名称:">
            <span style="color: #666666">{{ look1Form.productName }}</span>
          </el-form-item>
          <el-form-item label="型号:">
            <span style="color: #666666">{{ look1Form.type }}</span>
          </el-form-item>
          <!-- <el-form-item label="生产量:">
                <span style="color:  #666666 ;">{{look1Form.productFormulationId  }}</span>
            </el-form-item> -->
            <el-form-item  prop="neddSubjectId">
            <span slot="label" style="color: #ff0000">需求主体</span>
            <el-select v-model="look1Form.neddSubjectId" placeholder="请选择">
                  <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id" @click.native="changeSubject(item)"> </el-option>
                </el-select>
          </el-form-item>
          <el-form-item prop="quantity" :rules="[{ required: true, message: '请输入库存', trigger: 'blur' }]">
            <span slot="label" style="color: #ff0000">库存量:</span>
            <el-input v-model="look1Form.quantity" type="Number" placeholder="请输入" clearable>
              <template slot="append">吨</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="warehouseTime" :rules="[{ required: true, message: '请选择入库时间', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">入库时间:</span>
            <el-date-picker v-model="look1Form.warehouseTime"  type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look1Type = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="tanksaveOrUpdateFun('look1Form')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 入库明细 -->
    <el-dialog v-dialogDrag :visible.sync="look4Type" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">入库明细</span>
      <div class="dialoginfo">
        <el-table ref="look2List" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="list4" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="warehouseTime" label="入库时间" width="auto" align="center"></el-table-column>
          <el-table-column prop="neddSubject" label="需求主体" width="auto" align="center"></el-table-column>
          <el-table-column prop="stationName" label="站点" width="auto" align="center"></el-table-column>
          <el-table-column prop="warehouseName" label="库存仓" width="auto" align="center"></el-table-column>
          <el-table-column prop="quantity" label="数量" width="auto" align="center"></el-table-column>
          <el-table-column prop="costPrice" label="成本" width="auto" align="center"></el-table-column>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ table4Param.total }}条</div>
            <el-pagination :current-page.sync="table4Param.page" :page-size="table4Param.pageSize" layout="prev, pager, next, jumper" :total="table4Param.total" @current-change="queryWarehousingRecordFun()"></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look4Type = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 配比设置 -->
    <el-dialog v-dialogDrag :visible.sync="look6Type" width="900px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">配比设置</span>
      <div class="dialoginfo">
        <div style="padding-bottom: 20px">
          <el-button size="mini" class="bottom_all" style="margin-left: 0; position: relative" @click="addItem2()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table ref="mixtureRatio" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="mixtureRatioList" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="rawName" label="库存号" width="auto" align="center">
            <template slot-scope="scope">
              <el-select ref="raw" v-model="scope.row.rawWarehouseId" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in specialList" :key="item.rawWarehouseId" :label="item.warehouseName + '(' + item.rawName + ')'" :value="item.rawWarehouseId" @click.native="selectChanelSel(scope.$index, item)"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="物料名称" width="auto" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.rawName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="mixtureRatio" label="配合比值" width="auto" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.mixValue" placeholder="请输入" style="width: 90%" type="text" @input="v => (scope.row.mixValue = v.replace(/[^\d.]/g, ''))"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="deleteItem(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look6Type = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitMixtureRatio()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  tankqueryPage,
  tankdelete,
  tansaveOrUpdate,
  // deleteMixtureRatio,
  recordsqueryPage,
  savMoney,
  queryDataSource,
  deleteMoney,
  smartConfigqueryRawList,
  smartSaveOrUpdate,
  batchSmartUpdateOrDelete,
  smartqueryPage,
  queryProductMix,
  productWarehousing,
  queryWarehousingRecord,
  querySamrtMixtureRatioList,
  saveOrUpdateSmartMix,
} from "@/api/smart/specialmaterial/product.js";
import { permissionsCompanyList, getUserAutList } from "@/api/common.js";
import { getOrganizationBytypes } from "@/api/internetSales/chanceManagement";
import { getUserInfo } from "@/utils/auth.js";
export default {
  mixins: [mixin],
  data() {
    return {
      UserInfo: "",
      /*表格增删改查及下载接口*/
      queryPage: smartqueryPage,
      batchUpdateOrDelete: batchSmartUpdateOrDelete,
      /*表格数据*/
      table: [
        {
          label: "特材成品编码",
          width: "120",
          prop: "code",
          status: true,
        },
        {
          label: "站点",
          width: "130",
          prop: "stationName",
          status: true,
        },
        {
          label: "特材成品名称",
          width: "130",
          prop: "productName",
          status: true,
        },
        {
          label: "成品型号",
          width: "auto",
          prop: "type",
          status: true,
        },
        {
          label: "库存仓",
          prop: "warehouseName",
          status: true,
        },
        {
          label: "入库记录",
          prop: "wasteTank",
          status: true,
        },
        {
          label: "状态",
          width: "100",
          prop: "",
          status: true,
        },
        {
          label: "更新时间",
          width: "135",
          prop: "updateTime",
          status: true,
        },
        {
          label: "操作",
          width: "100",
          prop: "",
          status: true,
        },
      ],
      fromDate: {
        productName: "",
        stationId: "",
        stationName: "",
        rawWarehouseId: "",
        type: "",
        warehouseId: "",
        warehouseName: "",
        enable: 1,
      },
      companyIdList: [],
      tankListArrlist: [],
      look1Type: false,
      look1Form: {
        productName: "",
        productFormulationId: "",
        quantity: "",
        warehouseTime:"",
        neddSubjectId:"",
        neddSubject:"",
      },
      look2Type: false,
      table2Param: {
        tankName: "",
        tankType: 4,
        page: 1,
        pageSize: 10,
        total: 0,
      },
      maintenanceList: [],
      look3Type: false,
      fromDate3: {
        id: "",
        inventory: "",
        checkTime: "",
        operation: 1,
      },
      tankNameList: [],
      look4Type: false,
      list4: [],
      table4Param: {
        productFormulationId: "",
        page: 1,
        pageSize: 10,
        total: 0,
      },
      look5Type: false,
      lookForm5: {
        id: "",
        inventory: "",
      },
      look6Type: false,
      lookForm6: {
        id: "",
      },
      specialList: [],
      mixtureRatioList: [],
      delMixtureRatioList: [],
      specialProductId: null,
      istype: false,
      materialsProductId: "",
      priceVisible: false,
      stationList: [],
      priceDataSource: [],
      priceTotal: 0,
      pricePage: 1,
      stationId: "",
      rawMaterialList: [],
      addPHBItem: {},
      subjectList:[],
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.companyIdList = await permissionsCompanyList();
    this.stationList = await getUserAutList(true);
    this.tableParam = { ...this.tableParam, type: "", enable: "", stationId: "" };
    getOrganizationBytypes({ typeId: "19da56b9e85648059e3cf1e7da497da4,110572600018735104" }).then(res => {
      if (res.code === 1001) {
        this.subjectList = res.data;
      }
    });
    this.gettableData();
  },
  /*
   *copy(data)深拷贝数据,返回拷贝完的数据
   *gettableData获取列表数据
   *load下载
   *SortNum保持序列号
   * UpdateOrDelete禁用，启用，删除
   * submitFromDate保存更新数据
   */
  methods: {
    changeSubject(item){
      this.look1Form.neddSubject = item.name
    },
    /** 选择站点 */
    selectStationFun(val) {
      this.fromDate.stationId = val.id;
      this.fromDate.stationName = val.name;
      this.smartConfigqueryRawListFun(this.fromDate.stationId);
      console.log(" 选择站点", this.fromDate);
    },
    /** 选择原料 */
    selectRawWarehouseFun(val) {
      this.fromDate.warehouseId = val.warehouseId;
      this.fromDate.warehouseName = val.warehouseName + `(${val.rawName})`;
      this.fromDate.rawWarehouseId = val.rawWarehouseId;
      console.log("选择原料 ", this.fromDate);
    },
    /**(1)添加/修改特材成品时获取库存维护原料信息*/
    smartConfigqueryRawListFun(stationId) {
      smartConfigqueryRawList({ stationId: stationId }).then(res => {
        if (res.code == 1001) {
          let dataList = res.data;
          this.rawMaterialList = dataList.map(item => {
            item.name = item.warehouseName + "(" + item.rawName + ")";
            return item;
          });
        }
      });
    },
    /**入库*/
    look1Fun(val) {
      this.look1Type = true;
      this.look1Form.productFormulationId = val.id;
      this.look1Form.productName = val.productName;
      this.look1Form.type = val.type;
      this.look1Form.quantity = "";
      this.look1Form.neddSubject = "";
      this.look1Form.neddSubjectId = "";
      this.look1Form.warehouseTime = "";
    },
    /**入库-添加 */
    tanksaveOrUpdateFun(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          productWarehousing(this.look1Form).then(res => {
            if (res.code == 1001) {
              this.look1Type = false;
              this.$message({
                message: "保存成功",
                type: "success",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**入库记录-明细*/
    look4Fun(val) {
      console.log(" 入库记录-明细 ", val);

      if (!val.id) {
        this.$message({ message: "缺少数据ID", type: "warning" });
        return;
      }
      this.table4Param.productFormulationId = val.id;
      this.queryWarehousingRecordFun();
    },
    queryWarehousingRecordFun() {
      queryWarehousingRecord(this.table4Param).then(res => {
        if (res.code == 1001) {
          this.look4Type = true;
          this.list4 = res.data.data;
          this.table4Param.total = res.data.totalRows;
          console.log(" ", res);
        }
      });
    },
    handleDelete(data) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteMoney({ id: data.id }).then(res => {
            if (res.code === 1001) {
              this.$message.success("删除成功");
              this.initPriceTable();
            }
          });
        })
        .catch(() => {});
    },
    addSubmit() {
      this.$refs.priceRef.validate(valid => {
        if (valid) {
          const params = {
            ...this.priceForm,
            stationName: this.stationList.find(item => this.priceForm.stationId === item.id).name,
            materialsProductId: this.materialsProductId,
          };
          savMoney(params).then(res => {
            if (res.code === 1001) {
              this.$message.success("新增成功");
              this.initPriceTable();
            }
          });
        }
      });
    },
    initPriceTable() {
      const params = {
        stationId: this.stationId,
        page: this.pricePage,
        pageSize: 10,
        materialsProductId: this.materialsProductId,
      };
      queryDataSource(params).then(res => {
        if (res.code === 1001) {
          this.priceDataSource = res.data.data;
          this.priceTotal = res.data.totalRows;
        }
      });
    },
    /**入库提交 */
    tansaveOrUpdateFun2(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let inventory = this.tankNameList.find(res => this.lookForm5.id == res.id).inventory;
          this.lookForm5.inventory = Number(this.lookForm5.inventory) + Number(inventory);
          tansaveOrUpdate(this.lookForm5).then(res => {
            if (res.code == 1001) {
              this.look5Type = false;
              this.gettableData();
            }
          });
        } else {
          return false;
        }
      });
    },
    /**点开入库 */
    look5Fun(e) {
      this.look5Type = true;
      this.$nextTick(() => {
        this.$refs.lookForm5.resetFields();
      });
      this.tankNameList = [];
      let arr = e.tankId.split(",");
      tankqueryPage({ tankType: 2, companyId: e.companyId }).then(res => {
        arr.forEach(v => {
          let obj = res.data.data.find(res => v == res.id);
          if (obj) {
            this.tankNameList.push(obj);
          }
        });
      });
    },
    setPrice(data) {
      this.priceVisible = true;
      this.materialsProductId = data.id;
      this.initPriceTable();
    },
    /**配合比 - 原物料库存配置 */
    selectChanelSel(index, item) {
      this.mixtureRatioList[index].warehouseId = item.warehouseId;
      this.mixtureRatioList[index].warehouseName = item.warehouseName;
      this.mixtureRatioList[index].rawId = item.rawId;
      this.mixtureRatioList[index].rawName = item.rawName;
      this.mixtureRatioList[index].rawWarehouseId = item.rawWarehouseId;
      console.log("配合比 - 原物料库存配置 ", this.mixtureRatioList);
    },
    /* 配比设置 */
    look6Fun(e) {
      this.addPHBItem = e;
      this.look6Type = true;
      console.log(" 配比设置  ", e);
      this.delMixtureRatioList = [];
      this.specialList = [];
      if (!e.stationId) {
        this.$message({ message: "缺少数据站点ID", type: "warning" });
        return;
      }
      queryProductMix({ productId: e.id }).then(res => {
        if (res.code == 1001) {
          this.mixtureRatioList = res.data;
        }
      });

      querySamrtMixtureRatioList({ stationId: e.stationId }).then(res => {
        if (res.code == 1001) {
          this.specialList = res.data;
        }
      });
    },
    /*配合比 - 删除*/
    deleteItem(index) {
      this.mixtureRatioList.splice(index, 1);
    },
    /** 配合比 - 提交 */
    submitMixtureRatio() {
      this.type = false;
      console.log(this.mixtureRatioList);
      this.mixtureRatioList.forEach(v => {
        if (v.mixValue == null) {
          this.type = true;
        }
      });
      if ([...new Set(this.mixtureRatioList.map(item => item.rawWarehouseId))].length < this.mixtureRatioList.length) {
        this.$message({
          message: "原物料不能重复",
          type: "warning",
        });
        return;
      }
      if (this.type) {
        this.$message({
          message: "表格信息未填写完整！",
          type: "warning",
        });
        return;
      }
      if (!this.addPHBItem.id) {
        this.$message({
          message: "缺少数据保存ID",
          type: "warning",
        });
        return;
      }

      let param = { id: this.addPHBItem.id, productMixList: [...this.mixtureRatioList] };
      saveOrUpdateSmartMix(param).then(res => {
        if (res.code == 1001) {
          this.look6Type = false;
          this.$message({
            message: "添加成功",
            type: "success",
          });
        }
      });
    },

    /**盘点历史 */
    //   look4Fun(e) {
    //     console.log(e);
    //     this.look4Type = true
    //     this.table4Param.dataId = e.id
    //     this.recordsqueryPageFun()
    //   },
    /**盘点记录 */
    recordsqueryPageFun() {
      recordsqueryPage(this.table4Param).then(res => {
        this.list4 = res.data.data;
        this.table4Param.total = res.data.totalRows;
      });
    },
    /**每日盘点 */
    tansaveOrUpdateFun(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          tansaveOrUpdate(this.fromDate3).then(res => {
            if (res.code == 1001) {
              this.look3Type = false;
              this.gettableData();
            }
          });
        } else {
          return false;
        }
      });
    },
    /**点开每日盘点 */
    look3Fun(e) {
      this.look3Type = true;
      this.$nextTick(async () => {
        this.$refs.fromDate3.resetFields();
        this.fromDate3.productId = e.id;
        this.fromDate3.productType = e.type;
        this.fromDate3.productName = e.productName;
        this.tankNameList = [];
        let arr = e.tankId.split(",");
        await this.tankqueryPageFunList(e.companyId, e.id);
        arr.forEach(item => {
          let obj = this.tankListArrlist.find(items => item === items.id);
          if (obj) {
            this.tankNameList.push(obj);
          }
        });
      });
    },
    /**成品罐维护-删除 */
    tankdeleteFun(id) {
      this.$confirm("此操作将执行删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          tankdelete({ id: id }).then(res => {
            if (res.code == 1001) {
              this.tankqueryPageFun();
            }
          });
        })
        .catch(() => {});
    },

    /**特材罐维护查询 */
    tankqueryPageFun() {
      tankqueryPage(this.table2Param).then(res => {
        this.maintenanceList = res.data.data;
        this.table2Param.total = res.data.totalRows;
        this.gettableData();
      });
    },
    addItem2() {
      this.mixtureRatioList.push({
        warehouseId: null,
        warehouseName: null,
        rawId: null,
        rawName: null,
        rawWarehouseId: null,
        mixValue: null,
      });
    },
    /**添加提交 */
    pagessubmitFromDate() {
      let _this = this;
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          console.log("success submit!!", this.fromDate);
          _this.smartSaveOrUpdateuquest();
        } else {
          console.log("error submit!!");
        }
      });
    },
    smartSaveOrUpdateuquest() {
      let that = this;
      smartSaveOrUpdate(this.fromDate).then(res => {
        if (res.code == 1001) {
          that.addDialog = false;
          that.$message({ message: "保存成功", type: "success" });
          that.gettableData();
        }
      });
    },
    init() {
      /*重置数据*/
      this.tableParam.productName = "";
      this.tableParam.type = "";
      this.tableParam.enable = "";
      this.tableParam.stationId = "";
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.dialoginfo {
  .el-input,
  .el-select {
    width: 280px;
  }
}
.table_link {
  display: inline-block;
  width: 110px;
  margin: 0 10px 0 0;
  border: $bg_color 1px solid;
  color: $bg_color;
  border-radius: 3px;
  font-size: 14px;
  height: 30px;
  background: #ffffff;
  a {
    display: inline-block;
    line-height: 29.31px;
    color: $bg_color;
    text-decoration: none;
    font-size: 14px;
  }
}
</style>
  